/**
 * Protokolliert einen Supabase-Fehler LESBAR.
 *
 * `console.error('…', error)` allein zeigt in Electrons Konsole nur `Object` —
 * die eigentliche Meldung, der PostgREST-Code und der Hinweis bleiben
 * eingeklappt. Genau daran ist die Ursachensuche zu wiederholten 400/404ern
 * gescheitert. Die vier Felder werden deshalb ausgeschrieben.
 *
 * `code` ist dabei das Wertvollste: `42501` heißt fehlender GRANT (siehe
 * CLAUDE.md), `PGRST205` eine Tabelle, die PostgREST nicht kennt — also eine
 * nicht eingespielte Migration.
 */
export function logSupabaseError(label: string, error: unknown): void {
  const e = error as { message?: string; code?: string; details?: string; hint?: string } | null
  lastError = { label, code: e?.code ?? null, message: e?.message ?? String(error), details: e?.details ?? null }
  console.error(
    `[Supabase] ${label}:`,
    e?.code ? `code=${e.code}` : '',
    e?.message ?? String(error),
    e?.details ? `| details: ${e.details}` : '',
    e?.hint ? `| hint: ${e.hint}` : '',
  )
}

/** Der zuletzt protokollierte Supabase-Fehler — siehe `getLastSupabaseError`. */
export interface LastSupabaseError {
  label: string
  code: string | null
  message: string
  details: string | null
}

let lastError: LastSupabaseError | null = null

/**
 * Der zuletzt protokollierte Fehler, für die Sentry-Meldung eines
 * ausgebrannten Sync-Eintrags (`sync-queue.ts`).
 *
 * Die Cloud-Funktionen geben bei Fehlern nur `null` zurück; Sentry sah deshalb
 * „createCloudRewardUsage returned null" statt `23505` — der Code, der die
 * Ursache sofort genannt hätte (HAPPYTASK-1F, 2026-09-24). Der Push läuft
 * Eintrag für Eintrag, der letzte Fehler gehört also zum gerade gescheiterten.
 */
export function getLastSupabaseError(): LastSupabaseError | null {
  return lastError
}
